import type { RequestStatus } from "../lib/shared/timeOffTypes";
import { STATUS_LABEL } from "../lib/format";

export default function StatusBadge({ status }: { status: RequestStatus }) {
  return <span className={`status-badge status-${status}`}>{STATUS_LABEL[status]}</span>;
}
